
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/masterclasses/[id]",
      function () {
        return require("private-next-pages/masterclasses/[id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/masterclasses/[id]"])
      });
    }
  